import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ComponentsFactoryService {

  private mappingConfig: ComponentMappingConfig[];

  constructor() { }

  init(config: ComponentMappingConfig[]): void {
    this.mappingConfig = config;
  }

  getComponent(componentKey: string): any {
    const componentConfig = this.mappingConfig.find(config => config.key === componentKey);
    return componentConfig ? componentConfig.component : null;
  }
}

export interface ComponentMappingConfig {
  key: string;
  component: any;
}
